import React, { FormEvent, useState, useContext } from "react";
import AuthContext from "../../../contexts/AuthContext";
import { RouteProps, useHistory } from "react-router-dom";

import Select from "../../../components/Form/Select";
import Input from "../../../components/Form/Input";
import Checkbox from "../../../components/Form/Checkbox";
import Button from "../../../components/Form/Button";

import { SimpleResponse } from "../../../services/api/Request";
import Group, { IGroup } from "../../../services/api/Group";
import { SetModal } from "../../../components/Modal";

interface FormProps extends RouteProps {
	groups: IGroup[];
	group: IGroup;
	updateList?: Function
}

const Form: React.FC<FormProps> = ({ groups, group, updateList}) => {
	const { user } = useContext(AuthContext);
	const history = useHistory();
	const readOnly = user!.profile.name === "Viewer";
	const [response, setResponse] = useState<SimpleResponse>();
	const isUpdate = group && group.id;

	async function handleFormSubmit(event: FormEvent) {
		event.preventDefault();

		const formData: FormData = new FormData(event.target as HTMLFormElement);
		let data: any = {};
		formData.forEach((value: FormDataEntryValue, key: string) => {
			if (value !== "")
				data[key] = key !== "parent" ? value : { id: value };
		});
		const response: SimpleResponse = await (isUpdate
			? Group.Update(group.id, data)
			: Group.Create(data));

		setResponse(response);
	}

	function listGroups(group: IGroup[]): any {
		let result: object[] = [];

		for (let g of group) {
			result.push({ value: g.id, label: g.name });
			if (g.children) result = result.concat(listGroups(g.children));
		}

		return result;
	}

	function closeForm(e: any) {
		e.preventDefault();
		e.target.parentNode.parentNode.classList.remove("form--open");
		const contentWrapper = e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
		if (contentWrapper.classList.contains("form--open")) {
			contentWrapper.classList.toggle("form--open");
		}
	}

	return (
		<React.Fragment>
			{response ? SetModal.FromResponse(response, () => {
				setResponse(undefined);
				if (response.status === 200) {
					history.push({ pathname: "/empty" });
					history.goBack();
				}
			}) : null}
			<form className="container form form--border form--small" onSubmit={handleFormSubmit}>
				<Button onClick={closeForm} className="form__close close" />
				<h3 className="form__title">{isUpdate ? "Edit" : "Add New"}</h3>
				<Select
					disabled={readOnly}
					labelClass="form__label"
					name="parent"
					title="Parent"
					options={listGroups(groups)}
					defaultValue={group.parent ? group.parent.id : ""}
				/>
				<Input
					disabled={readOnly}
					name="name"
					title="Name"
					value={group.name}
					required={true}
				/>
				<Input
					disabled={readOnly}
					name="fixedApprover"
					title="Fixed Approver"
					value={group.fixedApprover}
					required={false}
				/>

				<div className="form__group-container form__group-container--switch">
					<Input
						disabled={readOnly}
						name="code"
						title="Code"
						value={group.code}
						required={true}
						maxLength={5}
					/>
					<Input
						disabled={readOnly}
						name="order"
						title="Order"
						type="number"
						value={group.order}
					/>
				</div>
				<div className="form__group-container form__group-container--switch">
					<Input
						disabled={readOnly}
						name="latitude"
						title="Latitude"
						type="number"
						step="0.01000"
						value={group.latitude}
					/>
					<Input
						disabled={readOnly}
						name="longitude"
						title="Longitude"
						type="number"
						step="0.01000"
						value={group.longitude}
					/>					
				</div>
				<div className="form__group-container form__group-container--switch">
					<Checkbox
						disabled={readOnly}
						name="active"
						title="Active"
						value="true"
						checked={group.active}
					/>
					<Checkbox
						disabled={readOnly}
						name="featured"
						title="Major"
						value="true"
						checked={group.featured}
					/>
				</div>			

				<div className="form__group-container">
					<Button
						disabled={readOnly}
						className="button button--blue button--icon button--save"
						title={isUpdate ? "Save" : "Send"}
					/>
				</div>
			</form>
		</React.Fragment>
	);
};

export default Form;
